/* Outdoors Nordic - "Byt storlek/farg" pa en varukorgsrad.
   Flyttad ur snippets/on-variant-change.liquid (rad 50, 2026-10-12). Den enda
   Liquid-varden, texten for slut i lager, ligger kvar i markupen som
   data-t-oos pa <on-variant-change>. Tidiga klick pa [data-vc-open] fangas av
   klickbryggan (snippets/on-click-bridge.liquid) och spelas om nar elementet
   ar definierat. */
/* INP (omgång 52): text skrivs i den befintliga textnoden när elementet bara har en.
   Att byta textContent tar bort och lägger till en nod, och då räknar webbläsaren om stilen
   för hela sidan (temats :has()-regler): ~100 ms per byte på mobil, mätt. Samma text syns. */
var __onTxt = window.__onTxt || (window.__onTxt = function (el, s) {
  if (!el) return;
  s = s == null ? '' : String(s);
  var f = el.firstChild;
  if (s !== '' && f && f.nodeType === 3 && !f.nextSibling) { if (f.nodeValue !== s) f.nodeValue = s; return; }
  el.textContent = s;
});
(function () {
  if (window.__onVcInit) return;
  window.__onVcInit = true;

  function isColorOpt(name) {
    return /(f[äa]rg|colou?r|farbe|kleur|couleur|colore|kolor|\bcor\b|v[äa]ri|farve)/i.test(name || '');
  }
  function swatchColor(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('bambu') > -1 || n.indexOf('bamboo') > -1) return '#39ff14';
    if (/(svart|black|sort|musta|schwarz|zwart|noir|nero|negro|czarn|preto)/.test(n)) return '#111111';
    if (/(vit|white|valk|weiss|weiß|wit|blanc|bianco|blanco|biał|branco)/.test(n)) return '#ffffff';
    if (/(salvi|salbei|salie|sauge|sage|sza[łl]wi|salva)/.test(n)) return '#9caf88';
    if (/(oliv|oliiv|olijf|oliwk|azeitona)/.test(n)) return '#6b6f3a';
    if (/(gr[öo]n|green|gr[øo]n|vihre|grün|groen|vert|verde|ziel)/.test(n)) return '#004E20';
    if (/(m[öo]rk ?bl[åa]|m[øo]rkebl[åa]|tummansinin|dark blue|dunkelblau|donkerblauw|bleu fonc|blu scuro|azul oscuro|ciemnoniebiesk|azul-escuro)/.test(n)) return '#1f3a63';
    if (/(ljus ?bl[åa]|lysebl[åa]|vaaleansinin|light blue|hellblau|lichtblauw|bleu clair|azzurro|azul claro|jasnoniebiesk|azul-claro)/.test(n)) return '#7fa8d8';
    if (/(bl[åa]|blue|sin|blau|blauw|bleu|\bblu\b|azul|niebie)/.test(n)) return '#1f4e79';
    if (/(gr[åa]|grey|gray|harmaa|grau|grijs|gris|grigio|szar|cinz)/.test(n)) return '#808080';
    if (/(beige|sand|khaki|kaki)/.test(n)) return '#c2b280';
    if (/(brun|brown|braun|marron|marrone|marrón|ruskea|bruin|brąz|braz|castanho)/.test(n)) return '#6b4423';
    if (/(r[öo]d|\bred\b|rot|rood|rouge|rosso|rojo|czerw|vermelh)/.test(n)) return '#b22222';
    return null;
  }

  class OnVariantChange extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.dialog = this.querySelector('[data-vc-dialog]');
      this.optsEl = this.querySelector('[data-vc-opts]');
      this.saveBtn = this.querySelector('[data-vc-save]');
      this.msg = this.querySelector('[data-vc-msg]');
      this.pname = this.querySelector('[data-vc-pname]');
      this.sgSlot = this.querySelector('[data-vc-sg]');
      var self = this;

      var closeBtn = this.querySelector('[data-vc-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      if (this.dialog) {
        // Klick inne i popupen ska ALDRIG bubbla till varukorgs-drawern (som annars
        // stänger sig vid klick "utanför"). Popupen ligger i top-layer ovanpå drawern,
        // så vi stoppar pekar-/klick-event här → varukorgen förblir öppen.
        this.dialog.addEventListener('click', function (e) {
          e.stopPropagation();
          if (e.target === self.dialog) self.close();
        });
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
          self.dialog.addEventListener(ev, function (e) { e.stopPropagation(); });
        });
      }

      this.optsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-oi]');
        if (!b) return;
        var i = parseInt(b.getAttribute('data-oi'), 10);
        self.selected[i] = b.getAttribute('data-ov');
        Array.prototype.forEach.call(b.parentNode.querySelectorAll('[data-oi]'), function (x) {
          x.classList.toggle('is-active', x === b);
        });
        self.recompute();
      });

      this.saveBtn.addEventListener('click', function () { self.save(); });

      // Storleksguide-knappen i popupen: dialogen stoppar click-bubbling (så
      // varukorgen inte stängs), därför når den aldrig on-szp:s document-lyssnare.
      // Vi öppnar guiden DIREKT via den exponerade funktionen istället.
      this.sgSlot.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sizepop]');
        if (!b) return;
        e.preventDefault();
        if (typeof window.__onSzpOpen === 'function') {
          window.__onSzpOpen(b);
        } else {
          // Fallback: vidarebefordra klicket till document om funktionen saknas.
          document.dispatchEvent(new CustomEvent('on-szp-open', { detail: { button: b } }));
        }
      });

      // Global delegation: alla "Byt storlek/färg"-triggers (även efter cart-rerender).
      if (!window.__onVcClick) {
        window.__onVcClick = true;
        document.addEventListener('click', function (e) {
          var b = e.target.closest('[data-vc-open]');
          if (!b) return;
          e.preventDefault();
          self.openFor(b);
        });
      }
    }

    close() {
      try { this.dialog.close(); } catch (e) { this.dialog.removeAttribute('open'); }
    }

    openFor(btn) {
      this.currentId = btn.getAttribute('data-vc-variant');
      this.key = btn.getAttribute('data-vc-key');
      this.qty = parseInt(btn.getAttribute('data-vc-qty') || '1', 10) || 1;
      __onTxt(this.pname, btn.getAttribute('data-vc-title') || '');
      // Klona radens storleksguide-knapp in i popupen.
      this.sgSlot.innerHTML = '';
      var actions = btn.closest('.cart-items__lineactions');
      var src = actions ? actions.querySelector('.cart-items__sg-src') : null;
      if (src && src.firstElementChild) {
        this.sgSlot.appendChild(src.firstElementChild.cloneNode(true));
        this.sgSlot.hidden = false;
      } else {
        this.sgSlot.hidden = true;
      }
      this.optsEl.innerHTML = '<div class="on-vc__loading">…</div>';
      this.saveBtn.disabled = true;
      this.msg.hidden = true;
      if (typeof this.dialog.showModal === 'function') {
        try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); }
      } else { this.dialog.setAttribute('open', ''); }
      var self = this;
      var handle = btn.getAttribute('data-vc-handle');
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { self.product = p; self.build(p); })
        .catch(function () { self.optsEl.innerHTML = ''; });
    }

    build(product) {
      this.optsEl.innerHTML = '';
      var names = product.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
      var values = names.map(function () { return []; });
      product.variants.forEach(function (v) {
        v.options.forEach(function (val, i) {
          if (values[i].indexOf(val) < 0) values[i].push(val);
        });
      });
      var cur = product.variants.filter(function (v) { return String(v.id) === String(this.currentId); }, this)[0] || product.variants[0];
      this.selected = cur.options.slice();
      var self = this;
      names.forEach(function (name, i) {
        var group = document.createElement('div'); group.className = 'on-vc__group';
        var lab = document.createElement('div'); lab.className = 'on-vc__glabel'; __onTxt(lab, name); group.appendChild(lab);
        var row = document.createElement('div'); row.className = 'on-vc__row';
        var color = isColorOpt(name);
        values[i].forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'on-vc__opt' + (color ? ' on-vc__opt--color' : '');
          b.setAttribute('data-oi', i);
          b.setAttribute('data-ov', val);
          if (color) {
            var hex = swatchColor(val);
            var st = hex ? ('background:' + hex + (hex === '#ffffff' ? ';box-shadow:inset 0 0 0 1px rgba(0,0,0,.25)' : '')) : '';
            var dot = document.createElement('span'); dot.className = 'on-vc__dot'; if (st) dot.setAttribute('style', st);
            var sp = document.createElement('span'); __onTxt(sp, val);
            b.appendChild(dot); b.appendChild(sp);
          } else {
            __onTxt(b, val);
          }
          if (self.selected[i] === val) b.classList.add('is-active');
          row.appendChild(b);
        });
        group.appendChild(row);
        self.optsEl.appendChild(group);
      });
      this.recompute();
    }

    recompute() {
      var product = this.product, target = null;
      for (var k = 0; k < product.variants.length; k++) {
        var v = product.variants[k], ok = true;
        for (var i = 0; i < this.selected.length; i++) {
          if (v.options[i] !== this.selected[i]) { ok = false; break; }
        }
        if (ok) { target = v; break; }
      }
      this.target = target;
      var changed = target && String(target.id) !== String(this.currentId);
      var avail = target && target.available;
      if (target && !avail) { this.msg.hidden = false; __onTxt(this.msg, this.getAttribute('data-t-oos') || ''); }
      else { this.msg.hidden = true; }
      this.saveBtn.disabled = !(changed && avail);
    }

    save() {
      if (this.saveBtn.disabled || !this.target) return;
      this.saveBtn.disabled = true;
      var self = this;
      var cic = document.querySelector('cart-items-component');
      var sid = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
      // Byte = INGEN ny produkt: ta bort den gamla raden FÖRST (change.js qty 0),
      // lägg sedan till den nya varianten av SAMMA produkt. Borttagning först →
      // ingen risk för dubblett om något skulle glappa. Sections hämtas från
      // add.js (stödjer Section Rendering säkert) → Horizon re-renderar drawern.
      var chBody = { id: self.key, quantity: 0 };
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(chBody)
      })
        .then(function () {
          var addBody = { items: [{ id: parseInt(self.target.id, 10), quantity: self.qty }] };
          if (sid) { addBody.sections = sid; addBody.sections_url = window.location.pathname; }
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(addBody)
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (added) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'on-variant-change', data: { source: 'on-variant-change', itemCount: cart.item_count, sections: added ? added.sections : null } }
              }));
              self.close();
            });
        })
        .catch(function () { window.location.href = '/cart'; });
    }
  }
  customElements.define('on-variant-change', OnVariantChange);
})();
